import { jsx as _jsx } from "react/jsx-runtime";
const ButtonContent = (props) => {
    return _jsx("div", { ...props });
};
export { ButtonContent };
